import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DfImageDirective } from '@df/module-image/df-image.directive';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { ShellComponent } from '@df/ui/common/shell/shell.component';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { GSAPModule } from '@df/ui/display/gsap/gsap.module';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent } from '@icms/core/content';
import { LocalVimeoPlayerComponent } from '../../../../../ui/display/media/vimeo-player.component';
import config from './full-width-banner-v3.config';
import { PageComponentFullWidthBannerV3ComponentData } from './full-width-banner-v3.interface';

@Component({
    selector: 'page-component-full-width-banner-v3',
    templateUrl: './full-width-banner-v3.html',
    styleUrl: './../full-width-banner/full-width-banner.scss',
    standalone: true,
    imports: [
        DfImageDirective,
        HrefComponent,
        GSAPModule,
        ICmsClientModule,
        LocalVimeoPlayerComponent,
        NgTemplateOutlet,
        RouterModule,
        ShellComponent,
        SizeClassDirective
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<PageComponentFullWidthBannerV3Component>(config)
export class PageComponentFullWidthBannerV3Component extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component!: PageComponentFullWidthBannerV3ComponentData;

    setPadding(item: PageComponentFullWidthBannerV3ComponentData): string | null {
        if (item.padding === 'with_padding') {
            return ' p-a p-t-3-s p-l-3-s p-r-3-s p-b-0-s';
        }

        return null;
    }
}
